export default __webpack_public_path__ + "static/media/Goldie 9781843626411.ab350ef8.jpg";